export default {
  fg: "#fff",
  bg: "#0e101c",
  accent: "#fb6899"
}
